const billingAccountsStyle = (theme) => ({
	dialogBody: {
		padding: '0 48px 157px',
		[theme.breakpoints.down('sm')]: {
			padding: '0 12px',
		},
	},
	header: {
		paddingBottom: 20,
	},
	subheader: {
		marginBottom: 24,
	},
	dialogHeader: {
		margin: '22px 0 8px',
	},
});

export default billingAccountsStyle;
